import { useMasterDetailWide } from '@hemmafixa/ui';
import { useCallback } from 'react';
import { useSearchParams } from 'react-router';

/**
 * The item shown in a MasterDetail panel, kept in the URL (`?selected=<id>`) so a reload or a shared link opens
 * the same item. Changing it replaces the history entry, so Back leaves the page instead of stepping through items.
 */
export function useSelectedParam(key = 'selected') {
  const [params, setParams] = useSearchParams();
  const selected = params.get(key);
  const setSelected = useCallback(
    (id: string | null) =>
      setParams(
        (current) => {
          const next = new URLSearchParams(current);
          if (id) next.set(key, id);
          else next.delete(key);
          return next;
        },
        { replace: true },
      ),
    [key, setParams],
  );
  return [selected, setSelected] as const;
}

/**
 * Which item a MasterDetail panel shows. From `lg` the panel is never empty: without a choice (or before the list
 * has loaded one) the first item is shown. On phones only a tapped item opens.
 */
export function useShownSelection(picked: string | null, ids: string[] | undefined) {
  const wide = useMasterDetailWide();
  if (!wide || picked) return picked;
  return ids?.[0] ?? null;
}
